import Big from "big.js";
import { AddonTogglerInfo } from "../enums";
import { filterPlanAddons } from "./filterPlanAddons";

export const addonNewMode = {
    newOnly: 'newOnly', // only show new addons
    oldOnly: 'oldOnly', // only show old addons
    all: 'all', // show all addons
};

/**
 * To process by merging the available addonPacks (offered by Bukku)
 * with the subscription plan addons (by the company)
 *
 * @param {Object[{type, ...}]} addonPacks - from GET /addon_packs (what is offered by Bukku - static)
 * @param {Object[{quantity, ...}]} planAddons - from GET /subscription addon_packs (what the company subscribed to - dynamic)
 * @param {Number} billingCycle - 1 or 12
 * @param {Boolean} removeZeroQty - remove addon packs with zero quantity
 * @param {Object[{quantity, ...}]} upcomingSubAddons - from GET /subscription
 * @param {Boolean} isInBetweenPeriod - is the subscription in between period (only used for AddonToggler)
 * @param {String} filterPlanAddonsConfig - config for filterPlanAddons
 *        - {mode: 'removeObject', selectedPlanType: 'LAUNCH',} - remove the non-related addons based on plans
 * @param {String} planAddonsFormat - 'array' or 'object'
 *         - 'array' - [{type, quantity}, ...]
 *         - 'object' - {type: quantity, ...}
 * @param {String} filterNewMode - filter for 2025 addons
 *         - addonNewMode.newOnly | addonNewMode.oldOnly | addonNewMode.all
 *
 */
export const processAddonPacks = ({
    addonPacks,
    planAddons = [],
    billingCycle = 1,
    removeZeroQty = false,
    upcomingSubAddons = [],
    isInBetweenPeriod = false,
    planAddonsFormat = 'array',
    filterPlanAddonsConfig = null, // {mode: 'removeObject', selectedPlanType: null,}
    filterNewMode,
}) => {
    // console.log('aaa QuotaTable processAddonPacks', {
    //     addonPacks,
    //     planAddons,
    //     billingCycle,
    //     removeZeroQty,
    //     upcomingSubAddons,
    //     planAddonsFormat,
    // });

    if (!addonPacks || !addonPacks.length)
        return [];

    let processedAddonPacks = addonPacks.map(pack => {
        const info = AddonTogglerInfo[pack.type];
        const {
            hideInPlans,
            // incrementStep,
            // hideIfPartner,
        } = info;

        let upcomingSubAddon, planAddon;
        switch (planAddonsFormat) {
            case 'array':
                upcomingSubAddon = upcomingSubAddons.find(addon => addon.type === pack.type);
                planAddon = planAddons.find(addon => addon.type === pack.type);
                break;
            case 'object':
                upcomingSubAddon = upcomingSubAddons[pack.type];
                planAddon = planAddons[pack.type];
                break;
            default:
                break;
        }

        let unitPrice = 0;
        if (billingCycle === 1)
            unitPrice = pack.monthly_price;
        if (billingCycle === 12)
            unitPrice = pack.yearly_price;

        let quantity, initialTotalValue;
        if (isInBetweenPeriod) {
            quantity = upcomingSubAddon ? upcomingSubAddon.quantity : 0;
            initialTotalValue = upcomingSubAddon ?
                Big(upcomingSubAddon.quantity).times(Big(pack.value)).toNumber() :
                0;
        }
        else {
            quantity = planAddon ? planAddon.quantity : 0;
            initialTotalValue = planAddon ? Big(planAddon.quantity).times(Big(pack.value)).toNumber() : 0;
        }

        return {
            ...pack,
            quantity,
            totalValue: planAddon ? Big(planAddon.quantity).times(Big(pack.value)).toNumber() : 0,
            initialTotalValue,
            currentTotalValue: planAddon ? Big(planAddon.quantity).times(Big(pack.value)).toNumber() : 0,
            upcomingTotalValue: upcomingSubAddon ?
                Big(upcomingSubAddon.quantity).times(Big(pack.value)).toNumber() :
                null,
            totalPrice: planAddon ? Big(planAddon.quantity).times(Big(unitPrice)).toNumber() : 0,
            hideInPlans,
        };
    });

    if (removeZeroQty)
        processedAddonPacks = processedAddonPacks.filter(pack => pack.quantity > 0);

    if (filterPlanAddonsConfig && filterPlanAddonsConfig.selectedPlanType) {
        processedAddonPacks = filterPlanAddons(
            processedAddonPacks,
            filterPlanAddonsConfig.selectedPlanType,
            filterPlanAddonsConfig?.mode,
        );
    }

    switch (filterNewMode) {
        case addonNewMode.newOnly:
            processedAddonPacks = processedAddonPacks.filter(pack => pack.is_new);
            break;
        case addonNewMode.oldOnly:
            processedAddonPacks = processedAddonPacks.filter(pack => !pack.is_new);
            break;
        case addonNewMode.all:
        default:
            // do nothing, keep all
            break;
    }

    return processedAddonPacks;
};
